import { FC, useMemo } from "react";
import { TotalProduction } from "../../../../../shared/interfaces/services/total-production";
import { TotalProductionCardComponent } from "../TotalProductionCardRender";
import { formattedPrice } from "../../../../../shared/utils";

interface TotalProductionCardProps {
  TotalProduction: TotalProduction;
  loading?: boolean;
}

export const TotalProductionCard: FC<TotalProductionCardProps> = ({
  TotalProduction,
  loading,
}) => {    
    const {
        rama,
        mes,
        anio,
        primaEmitida,
        premioEmitido,
        comisionEmitida,
        primaCobrada,
        premioCobrado,
        comisionCobrada
    } = TotalProduction;

    const renderCurrency = (value: string) => {
      return `$ ${formattedPrice(value.toString())}`
    }

    const COLUMNS_DATA_PRODUCTION = useMemo(() => [
        {
          label: 'Mes',
          value: mes,
        },
        {
          label: 'Año',
          value: anio,
        },
        {
          label: 'Prima Emitida',
          value: renderCurrency(primaEmitida),
        },
        {
          label: 'Premio Emitida',
          value: renderCurrency(premioEmitido),
        },
        {
          label: 'Comisión Emitida',
          value: renderCurrency(comisionEmitida),
        },
        {
          label: 'Prima Cobrada',
          value: renderCurrency(primaCobrada),
        },
        {
          label: 'Premio Cobrada',
          value: renderCurrency(premioCobrado),
        },
        {
          label: 'Comisión Cobrada',
          value: renderCurrency(comisionCobrada),
        },
      ],
      [
        mes,
        anio,
        primaEmitida,
        premioEmitido,
        comisionEmitida,
        primaCobrada,
        premioCobrado,
        comisionCobrada
      ]);

    return (
        <TotalProductionCardComponent
          title={rama}
          article={undefined}
          actions={undefined}
          loading={loading}
          columnsData={COLUMNS_DATA_PRODUCTION}
        />
    );
}